import { useQueryClient, useMutation } from "@tanstack/react-query";
import { deleteProject } from "./useDeleteProject.query";
import { useDeleteProjectProps } from "./useDeleteProject.types";

export function useDeleteProject() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ["delete_project"],
        mutationFn: async (projectId: useDeleteProjectProps) => {
            const res = await deleteProject(projectId);
            return res;
        },
        onSuccess: ()=> {
            queryClient.invalidateQueries({queryKey: ["projects_list"]});
            queryClient.invalidateQueries({queryKey: ["project"]});
        }
    });
}
